import type { Currency, NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Loveth Tasty Global',
    tagline: 'From Our Kitchen To The World',
    description: 'Premium catering from Akure, Nigeria. Weddings, corporate events, private chef service, small chops, food trays and authentic Nigerian meals for your loved ones, ordered from anywhere in the world.',
    url: getOrigin(),
    ogImage: 'https://loveth-tasty-global.cdn.modulify.website/brand/nigerian-feast.jpg'
}

export const contact = {
    phoneDisplay: '0703 232 8958',
    phoneInternational: '+234 703 232 8958',
    phoneHref: 'tel:+2347032328958',
    whatsappNumber: '2347032328958',
    email: 'danielloveth2020@gmail.com',
    city: 'Akure',
    location: 'Akure, Ondo State, Nigeria',
    mapsHref: 'https://www.google.com/maps/search/?api=1&query=Akure%2C%20Ondo%20State%2C%20Nigeria'
}

export const whatsappLink = (message?: string): string => {
    const base = `https://wa.me/${contact.whatsappNumber}`

    return message ? `${base}?text=${encodeURIComponent(message)}` : base
}

export const defaultWhatsappMessage = "Hello Loveth Tasty, I'd like to make an enquiry about your catering services."

export const navLinks: Array<NavLink> = [
    { label: 'Home', href: '/', section: 'home' },
    { label: 'About Us', href: '/#about', section: 'about' },
    { label: 'Our Services', href: '/#services', section: 'services' },
    { label: 'Our Menu', href: '/#menu', section: 'menu' },
    { label: 'Gallery', href: '/#gallery', section: 'gallery' },
    { label: 'Testimonials', href: '/#testimonials', section: 'testimonials' },
    { label: 'Contact', href: '/#contact', section: 'contact' }
]

export const currencies: Array<{ code: Currency, label: string, symbol: string, note: string }> = [
    { code: 'NGN', label: 'Nigerian Naira', symbol: '₦', note: 'Ideal if you or a relative will pay locally in Nigeria.' },
    { code: 'USD', label: 'US Dollar', symbol: '$', note: 'For customers in the USA, Canada and beyond.' },
    { code: 'GBP', label: 'British Pound', symbol: '£', note: 'For customers in the UK and Ireland.' }
]

export const eventTypes: Array<string> = [
    'Wedding or traditional ceremony',
    'Corporate event',
    'Birthday celebration',
    'Naming ceremony',
    'Burial or memorial',
    'Housewarming',
    'Anniversary',
    'Private dinner at home',
    'Other celebration'
]

export const enquirySubjects: Array<string> = [
    'General enquiry',
    'Catering quote',
    'Full menu and prices',
    'Order for family in Nigeria',
    'Corporate partnership'
]

export const diasporaCountries: Array<string> = [
    'United Kingdom',
    'United States',
    'Canada',
    'Ireland',
    'Germany',
    'Netherlands',
    'United Arab Emirates',
    'South Africa',
    'Australia',
    'Nigeria',
    'Other country'
]
